import Resource from "utils/resourcesUtil";

export function login(email, password, disableDeviceId = false) {
  const headers = {
    email,
    password,
  };
  if (disableDeviceId) {
    headers.deviceId = undefined;
  }

  const promise = Resource.post(
    "purchase-service/api/v1/customers/login",
    {},
    { headers }
  );
  return new Promise((resolve, reject) => {
    promise.then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

export function currentUser(token) {
  const promise = Resource.get("purchase-service/api/v1/customers/current", {
    headers: { Authorization: `Bearer ${token}` }
  });

  return new Promise((resolve, reject) => {
    promise.then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

/**
 * @param {string} ssn4Digits
 * @param {string} email
 * @return {Promise}
 */
export function registerAccount(ssn4Digits, email) {
  const headers = {
    "ssn-4-digits": ssn4Digits,
    email
  };

  const config = {
    headers
  };

  return new Promise((resolve, reject) => {
    Resource.put(
      "purchase-service/api/v1/customers/registration/email/resend",
      null,
      config
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

/**
 * @param {string} ssn4Digits
 * @param {string} email
 * @return {Promise}
 */
export function forgotPassword(ssn4Digits, email) {
  const headers = {
    "ssn-4-digits": ssn4Digits,
    email
  };

  const config = {
    headers
  };

  return new Promise((resolve, reject) => {
    Resource.put(
      "purchase-service/api/v1/customers/registration/forgot-password",
      null,
      config
    ).then(
      response => resolve(response.data),
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}

export async function resetPassword(email, temporaryPassword, newPassword) {
  const loginData = await login(email, temporaryPassword, true);

  return new Promise((resolve, reject) => {
    let deviceId = localStorage.getItem("deviceId");
    deviceId = 'MY-SUNBIT-WEB-' + deviceId;
    const headers = {
      Authorization: `Bearer ${loginData.access_token}`
    };
    Resource.put(
      "purchase-service/api/v1/customers/current/password",
      {
        deviceId,
        oldPassword: temporaryPassword,
        newPassword
      },
      { headers }
    ).then(
      async () => {
        const loginData = await login(email, newPassword);
        const user = await currentUser(loginData.access_token);
        resolve({ loginData, user });
      },
      error => reject(Resource.createErrorWithHttpStatus(error))
    );
  });
}



// WEBPACK FOOTER //
// ./src/services/api/auth.js